<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="模板名称" style="width:220px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增模板</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="{ $index }">{{ (page - 1) * pageSize + $index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="name" label="模板名称" min-width="160" />
      <el-table-column prop="roleNames" label="评价针对角色" min-width="180" show-overflow-tooltip />
      <el-table-column prop="enabled" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.enabled === 1 ? 'success' : 'info'">{{ row.enabled === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id ? '编辑评价模板' : '新增评价模板'" :visible.sync="visible" width="680px">
      <el-form :model="form" label-width="100px" v-loading="metaLoading">
        <el-form-item label="模板名称" required>
          <el-input v-model="form.name" maxlength="128" />
        </el-form-item>
        <el-form-item label="针对角色" required>
          <el-select v-model="form.roleIdList" multiple filterable clearable placeholder="选择角色" style="width:100%">
            <el-option v-for="r in roles" :key="r.id" :label="r.roleName" :value="r.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="评分项" required>
          <el-button size="mini" type="primary" plain @click="addItem">添加选项</el-button>
          <el-table :data="form.items" border size="small" style="margin-top:8px">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column label="选项" min-width="220">
              <template slot-scope="{ row }">
                <el-select v-model="row.itemDictId" filterable placeholder="选择评分项" style="width:100%">
                  <el-option
                    v-for="d in evaluateItems"
                    :key="d.id"
                    :label="d.dictLabel"
                    :value="d.id"
                    :disabled="isItemUsed(d.id, row)"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column width="80">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.items.splice($index,1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <p class="tip">评分项来自字典 EVALUATE_ITEM；客户评价时按 1～5 星打分。</p>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listEvaluateTpls, getEvaluateTpl, saveEvaluateTpl, deleteEvaluateTpl } from '../../api/project'
import { listDictOptions } from '../../api/dict'
import { listRoles } from '../../api/sys'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

function parseIds(csv) {
  if (!csv) return []
  return String(csv).split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !Number.isNaN(n))
}

export default {
  name: 'EvaluateTpl',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      keyword: '',
      list: [],
      loading: false,
      saving: false,
      visible: false,
      metaLoading: false,
      roles: [],
      evaluateItems: [],
      form: { id: null, name: '', roleIdList: [], remark: '', enabled: 1, items: [] }
    }
  },
  created() {
    this.load()
  },
  methods: {
    async loadMeta() {
      this.metaLoading = true
      try {
        const [roles, items] = await Promise.all([
          listRoles(),
          listDictOptions('EVALUATE_ITEM')
        ])
        this.roles = ((roles && roles.data) || []).filter(r => r.roleCode !== 'SUPPLIER' && r.roleCode !== 'WORKER')
        this.evaluateItems = (items && items.data) || []
      } finally {
        this.metaLoading = false
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await listEvaluateTpls({ keyword: this.keyword || undefined })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    isItemUsed(dictId, currentRow) {
      return this.form.items.some(i => i !== currentRow && i.itemDictId === dictId)
    },
    addItem() {
      this.form.items.push({ itemDictId: null, sortNo: this.form.items.length })
    },
    async openEdit(row) {
      await this.loadMeta()
      if (!row) {
        this.form = { id: null, name: '', roleIdList: [], remark: '', enabled: 1, items: [{ itemDictId: null, sortNo: 0 }] }
        this.visible = true
        return
      }
      const res = await getEvaluateTpl(row.id)
      const d = res.data || {}
      this.form = {
        id: d.id,
        name: d.name || '',
        roleIdList: parseIds(d.roleIds),
        remark: d.remark || '',
        enabled: d.enabled == null ? 1 : d.enabled,
        items: (d.items || []).map((it, idx) => ({
          itemDictId: it.itemDictId,
          sortNo: it.sortNo != null ? it.sortNo : idx
        }))
      }
      if (!this.form.items.length) this.addItem()
      this.visible = true
    },
    async save() {
      const f = this.form
      if (!f.name) return this.$message.warning('请填写模板名称')
      if (!f.roleIdList.length) return this.$message.warning('请选择针对角色')
      if (!f.items.length || f.items.some(i => !i.itemDictId)) {
        return this.$message.warning('请完善评分项')
      }
      this.saving = true
      try {
        await saveEvaluateTpl({
          id: f.id,
          name: f.name,
          roleIds: f.roleIdList.join(','),
          remark: f.remark,
          enabled: f.enabled,
          items: f.items.map((i, idx) => ({
            itemDictId: i.itemDictId,
            sortNo: idx
          }))
        })
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm(`确认删除评价模板「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteEvaluateTpl(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.tip { margin:8px 0 0; color:#94a3b8; font-size:12px; }
</style>
